import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { SearchBar } from 'components';
import { useDebounce, useBreakpoint } from 'hooks';
import { Button, Icon as IconV2, Text } from '@bb/elements-web';
import { StyledOpenHousesSearchWrapper } from './StyledSearchComponents';
import MyBrokerageContext from '../MyBrokerageContext';
import { SearchComponentType } from '../types';

const OpenHousesSearch: SearchComponentType = React.forwardRef((props, ref) => {
  const { queryData, setQueryData } = React.useContext(MyBrokerageContext);
  const [localSearchTerm, setLocalSearchTerm] = React.useState(
    queryData.searchTerm,
  );
  const debouncedTerm = useDebounce(localSearchTerm, 500);
  React.useEffect(() => {
    setQueryData(prev => ({ ...prev, searchTerm: debouncedTerm }));
  }, [debouncedTerm, setQueryData]);

  const { md } = useBreakpoint();
  return (
    <StyledOpenHousesSearchWrapper $stretch={!md}>
      <SearchBar
        value={localSearchTerm}
        onChange={setLocalSearchTerm}
        allowClear
        placeholder="Search"
        ref={ref}
        shape="round"
      />
      <RouterLink to="/open_houses/add">
        <Button
          dataCy="add-needs-button"
          size="small"
          styleOverride={{ minWidth: '80px' }}
        >
          <IconV2 icon="plusOutlined" color="white" />
          <Text color="white">Add</Text>
        </Button>
      </RouterLink>
    </StyledOpenHousesSearchWrapper>
  );
});

export default OpenHousesSearch;
